<template>
  <notification @click="handleClick" :is-read="isRead" :created-at="createdAt">
    <h2 class="truncate">Récurrence</h2>
    <p>Une commande récurrente n'a pas pu être générée.</p>
  </notification>
</template>

<script>
import Notification from '../notifications/Notification.vue';
import notification from '../../mixins/notification';

export default {
  components: { Notification },

  mixins: [notification],

  methods: {
    handleClick() {
      this.markAsRead().then(() =>
        this.$modal.open(
          'notification-recurring-order-product-not-enough-stock',
          this.notification,
        ),
      );
    },
  },
};
</script>
